<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  h1 {
    font-size: 16px;

    &.extension {
      color: #bf83ff;
    }

    &.projects {
      color: colors.get(moduleProjects_50);
    }
  }
</style>

<script>
  import { LICENSE_TO_FEATURE } from "../../../elements/Marketing/BookDemo/assets";

  let { license, children } = $props();
  let mod = LICENSE_TO_FEATURE[license];
</script>

<h1 class={license}>
  {#if children}
    {@render children()}
  {:else}
    {mod}
  {/if}
</h1>
